import { render } from "./summary-dim-rating.html?vue&type=template&id=bcb5b2f6"
import script from "./SummaryDimRating.vue?vue&type=script&lang=ts"
export * from "./SummaryDimRating.vue?vue&type=script&lang=ts"

import "./summary-dim.scss?vue&type=style&index=0&lang=scss"
import "./summary-dim-rating.scss?vue&type=style&index=1&lang=scss"
script.render = render

export default script